export default {
      id: "nav-dashboard-usage",
      viewBox: "0 0 832 1024",
      url: __webpack_public_path__ + "icons.svg#nav-dashboard",
      toString: function () {
        return this.url;
      }
    }